import { alpha, type CSSVariablesResolver } from '@mantine/core';
import { palette } from './palette';

// Mantine САМ эмитит --mantine-primary-color-filled (=--mantine-color-primary-5=
// --primary-60-main), --mantine-radius-default (из theme.defaultRadius) и
// --mantine-primary-color-contrast (= --mantine-color-white = --neutral-00, см. theme.white
// в theme.ts) — их НЕ переопределяем.
//
// Тёмный блок. Палитра задана ссылками var(--*) на _tokens.scss, и тёмный блок _tokens.scss
// уже ИНВЕРТИРУЕТ рампы (neutral-90 — светлый текст, primary-80 — самый светлый синий).
// Mantine же в тёмной схеме применяет к тюплам свои формулы «для тёмной» (light-вариант =
// darken(9-й ступени), light-color = 0-я ступень, outline = 1-я) в расчёте на то, что тюпл
// тот же, что в светлой, — поверх нашей уже инвертированной рампы это двойная инверсия:
// тёмный текст на тёмной заливке. Поэтому производные цветов в тёмной схеме пинятся
// теми же формулами, что Mantine использует в светлой: рампа переключилась сама, формулы
// остаются. Нейтральные роли (text/body/default*/placeholder/dimmed/disabled*) пинятся на
// токены напрямую — дефолты Mantine там ссылаются на его собственную серую тему.
// Исключение — само семейство dark: его тюпл ориентирован по-мантиновски (0 — светлый,
// 9 — тёмный), и родные тёмные формулы Mantine для него верны.
const darkColorDerivatives = Object.fromEntries(
    (Object.keys(palette) as (keyof typeof palette)[])
        .filter((name) => name !== 'dark')
        .flatMap((name) => [
            [`--mantine-color-${name}-text`, `var(--mantine-color-${name}-filled)`],
            [`--mantine-color-${name}-light`, `var(--mantine-color-${name}-1)`],
            [`--mantine-color-${name}-light-hover`, `var(--mantine-color-${name}-2)`],
            [`--mantine-color-${name}-light-color`, `var(--mantine-color-${name}-9)`],
            [`--mantine-color-${name}-outline`, `var(--mantine-color-${name}-5)`],
            [`--mantine-color-${name}-outline-hover`, alpha(palette[name][5], 0.05)],
        ]),
);

export const cssVariablesResolver: CSSVariablesResolver = () => ({
    variables: {},
    light: {},
    dark: {
        '--mantine-color-text': 'var(--neutral-90)',
        '--mantine-color-bright': 'var(--neutral-90)',
        '--mantine-color-body': 'var(--neutral-00)',
        '--mantine-color-dimmed': 'var(--neutral-50)',
        '--mantine-color-placeholder': 'var(--neutral-40)',
        '--mantine-color-anchor': 'var(--mantine-color-primary-5)',
        '--mantine-color-error': 'var(--error-60-main)',
        '--mantine-color-default': 'var(--neutral-00)',
        '--mantine-color-default-hover': 'var(--neutral-05)',
        '--mantine-color-default-color': 'var(--neutral-90)',
        '--mantine-color-default-border': 'var(--neutral-20)',
        '--mantine-color-disabled': 'var(--neutral-10)',
        '--mantine-color-disabled-color': 'var(--neutral-40)',
        '--mantine-color-disabled-border': 'var(--neutral-20)',
        ...darkColorDerivatives,
    },
});
